import './style.scss'
import { AppText, CustomContainer, AppSpan, GridContainer, FlexColumn, TableHeadCell, FlexRow } from "src/style";
import { BsThreeDotsVertical } from 'react-icons/bs';
import BillIcon from 'src/assets/svg/bills-tx-icon'
import BillIconD3 from 'src/assets/svg/bills-tx-icon-d3'
import InvestmentIcon from 'src/assets/svg/investment-circle-icon'
import { getCharacterToDispay, moneyFormat } from 'src/utils/utility';
import helpers from 'src/utils/helpers'
import { Design } from 'src/model';
import { capsule } from '../capsule';

let isMobileScreen = window.matchMedia('(max-width: 600px)').matches

function handleDateFormat (datetime: string) {
    let formatedDateTime = helpers.splitDateTime(datetime)
    return `${formatedDateTime?.slashedDate} ${formatedDateTime?.time}`
}

function getTxIcon () {
    const institutionData = localStorage.getItem('institutionData')
    const design = JSON.parse(institutionData!)?.design
    let icon = design === Design.DESIGN_1 ?
        <BillIcon 
            className='icon-component'
            style={{flexBasis: 'auto', flexShrink: '0', flexGrow: '0'}}
        />
        : design === Design.DESIGN_2 ? null
            :   <BillIconD3 
                    className='icon-component'
                    style={{flexBasis: 'auto', flexShrink: '0', flexGrow: '0'}}
                />

    return icon
}

export const loanColumns = (handleAction: any, currency:string,isHideBalance = false) => [
    {
        name: <TableHeadCell>Investment</TableHeadCell>,
        selector:(row: any) => (
            <FlexRow gap='1.3'>
                {getTxIcon()}
                <AppText fontWeight='600' color='#101828'>{row.product}</AppText>
            </FlexRow>
        ),
        minWidth: '20rem',
        wrap: true
    },
    {
        name: <TableHeadCell>Amount </TableHeadCell>,
        selector:(row: any) => 
            <AppText color={row.debit?.trim() ? '#FB4E4E' : '#2AC769'}>
                {isHideBalance ? 'XXXXXXX' : `${row.debit?.trim() ? '-' : '+'}${moneyFormat(row.loanAmount, true,currency)}`}
            </AppText>,
        minWidth: '15rem'
    },
    {
        name: <TableHeadCell>Date</TableHeadCell>,
        selector:(row: any) => <AppText color='#667085'>{row?.transactionDate && !row?.transactionDate.includes(' ') ? helpers.convertUTCToLocalTime(row?.transactionDate) : row.transactionDate}</AppText>,
        minWidth: '20rem'
    },
    {
        name: <TableHeadCell>Status</TableHeadCell>,
        selector:(row: any) => (<p className='text-[#ccc] '>{capsule(row.realLoanStatus)}</p>),
        minWidth: '15rem',
        wrap: true
    },
    {
        name: <TableHeadCell></TableHeadCell>,
        selector:(row: any) => 
            <AppText 
                fontWeight='500' color='#0A756F'
                hoverColor='#667085' cursor='pointer'
                onClick={() => handleAction(row)}
            >
                View Details
            </AppText>,
        right: true
    },
    // {
    //     name: <TableHeadCell></TableHeadCell>,
    //     right: true,
    //     selector:(row: any) => (
    //         <CustomContainer>
    //             <select style={{position: 'absolute', top: '0', left: '0', zIndex: '3', opacity: '0'}}>
    //                 <option>View</option>
    //                 <option>Mark as resolved</option>
    //                 <option>Unmarked as resolved</option>
    //             </select>
    //             <AppSpan color='#98A2B3'>
    //                 <BsThreeDotsVertical/>
    //             </AppSpan>
    //         </CustomContainer>
    //     ),
    //     //width: '20rem'
    // }
]

export const transactionColumns = (handleAction: any, currency:string, isHideBalance = false) => [
    {
        name: <TableHeadCell>Narration</TableHeadCell>,
        selector:(row: any) => (
            <FlexRow gap='1.3'>
                {getTxIcon()}
                <AppText fontWeight='600' color='#101828'>{getCharacterToDispay(row.narration, isMobileScreen ? 35 : 50)}</AppText>
            </FlexRow>
        ),
        minWidth: isMobileScreen ? '28rem' : '45rem',
        wrap: true
    },
    {
        name: <TableHeadCell>Amount </TableHeadCell>,
        selector:(row: any) => 
            <AppText color={row.debit?.trim() ? '#FB4E4E' : '#2AC769'}>
                {isHideBalance ? 'XXXXXXX' : `${row.debit?.trim() ? '-' : '+'}${moneyFormat(row.amount, true,currency)}`}
            </AppText>,
        minWidth: '15rem'
    },
    {
        name: <TableHeadCell>Date</TableHeadCell>,
        selector:(row: any) => <AppText color='#667085'>{row?.transactionDate ? helpers.convertUTCToLocalTime(row?.transactionDate,true) : row.transactionDate}</AppText>,
        minWidth: '20rem'
    },
    {
        name: <TableHeadCell></TableHeadCell>,
        selector:(row: any) => 
            <AppText 
                fontWeight='500' color='#0A756F'
                hoverColor='#667085' cursor='pointer'
                onClick={() => handleAction(row)}
            >
                View Details
            </AppText>,
        right: true
    },
    // {
    //     name: <TableHeadCell></TableHeadCell>,
    //     right: true,
    //     selector:(row: any) => (
    //         <CustomContainer>
    //             <select style={{position: 'absolute', top: '0', left: '0', zIndex: '3', opacity: '0'}}>
    //                 <option>View</option>
    //                 <option>Mark as resolved</option>
    //                 <option>Unmarked as resolved</option>
    //             </select>
    //             <AppSpan color='#98A2B3'>
    //                 <BsThreeDotsVertical/>
    //             </AppSpan>
    //         </CustomContainer>
    //     ),
    //     //width: '20rem'
    // }
]

export const transactionData = [
    {
        narration: 'Transfer to Oluwatobi Olowu',
        amount: 100_000,
        date: '2023-04-03T11:24:27.495Z',
        txRef: '3435RET5434',
        transactionDate: '2023-04-03T11:24:27.495Z',
        transactionReference: "3435RET5434"
    },
    {
        narration: 'Transfer to IFOTA DEV',
        amount: 100_000,
        date: '2023-04-03T11:24:27.495Z',
        txRef: '3435RET5434',
        transactionDate: '2023-04-03T11:24:27.495Z',
        transactionReference: "3435RET5434"
    },
    {
        narration: 'MTN Airtime Recharge',
        amount: 100_000,
        date: '2023-04-03T11:24:27.495Z',
        txRef: '3435RET5434',
        transactionDate: '2023-04-03T11:24:27.495Z',
        transactionReference: "3435RET5434"
    },
    {
        narration: 'Inflow from Oluwatobi Olowu',
        amount: 100_000,
        date: '2023-04-03T11:24:27.495Z',
        txRef: '3435RET5434',
        transactionDate: '2023-04-03T11:24:27.495Z',
        transactionReference: "3435RET5434"
    },
    {
        narration: 'MTN Airtime Recharge',
        amount: 100_000,
        date: '2023-04-03T11:24:27.495Z',
        txRef: '3435RET5434',
        transactionDate: '2023-04-03T11:24:27.495Z',
        transactionReference: "3435RET5434"
    },
    {
        narration: 'Inflow from Oluwatobi Olowu',
        amount: 100_000,
        date: '2023-04-03T11:24:27.495Z',
        txRef: '3435RET5434',
        transactionDate: '2023-04-03T11:24:27.495Z',
        transactionReference: "3435RET5434"
    },
    {
        narration: 'Transfer to IFOTA DEV',
        amount: 100_000,
        date: '2023-04-03T11:24:27.495Z',
        txRef: '3435RET5434',
        transactionDate: '2023-04-03T11:24:27.495Z',
        transactionReference: "3435RET5434"
    },
    {
        narration: 'MTN Airtime Recharge',
        amount: 100_000,
        date: '2023-04-03T11:24:27.495Z',
        txRef: '3435RET5434',
        transactionDate: '2023-04-03T11:24:27.495Z',
        transactionReference: "3435RET5434"
    },
    {
        narration: 'Transfer to Oluwatobi Olowu',
        amount: 100_000,
        date: '2023-04-03T11:24:27.495Z',
        txRef: '3435RET5434',
        transactionDate: '2023-04-03T11:24:27.495Z',
        transactionReference: "3435RET5434"
    },
    {
        narration: 'Transfer to IFOTA DEV',
        amount: 100_000,
        date: '2023-04-03T11:24:27.495Z',
        txRef: '3435RET5434',
        transactionDate: '2023-04-03T11:24:27.495Z',
        transactionReference: "3435RET5434"
    }
]

// =============== INSIGHTS =============================

export const insightColumns = (handleAction: any, type: number, currency:string, isHideBalance = false) => [
    {
        name: <TableHeadCell>{type === 0 ? 'Expense Category' : 'Inflow'}</TableHeadCell>,
        selector:(row: any) => (
            <FlexRow gap='1.3'>
                {getTxIcon()}
                <AppText fontWeight='600' color='#101828'>{getCharacterToDispay(row.category, isMobileScreen ? 35 : 50)}</AppText>
            </FlexRow>
        ),
        minWidth: isMobileScreen ? '28rem' : '45rem',
        wrap: true
    },
    {
        name: <TableHeadCell>Amount</TableHeadCell>,
        selector:(row: any) => 
            <AppText color='#FB4E4E'>
                {isHideBalance ? 'XXXXXXX' : `-${moneyFormat(row.total, true,currency)}`}
            </AppText>,
        minWidth: '15rem'
    },
    {
        name: <TableHeadCell></TableHeadCell>,
        selector:(row: any) => 
            <AppText 
                fontWeight='500' color='#0A756F'
                hoverColor='#667085' cursor='pointer'
                onClick={() => handleAction(row)}
            >
                View Details
            </AppText>,
        right: true
    }
]


export const insightData = [
    {
        narration: 'Transfer to Oluwatobi Olowu',
        amount: '100,000',
        date: 'Jan 4, 2022',
        txRef: '3435RET5434'
    },
    {
        narration: 'Transfer to IFOTA DEV',
        amount: '100,000',
        date: 'Jan 4, 2022',
        txRef: '3435RET5434'
    },
    {
        narration: 'MTN Airtime Recharge',
        amount: '100,000',
        date: 'Jan 4, 2022',
        txRef: '3435RET5434'
    },
    {
        narration: 'Inflow from Oluwatobi Olowu',
        amount: '100,000',
        date: 'Jan 4, 2022',
        txRef: '3435RET5434'
    }
]

// =================INVESTMENTS =============================

export const InvestmentColumns = (handleAction: any, currency:string) => [
    {
        name: <TableHeadCell>Investment</TableHeadCell>,
        selector:(row: any) => (
            <FlexRow gap='1.3'>
                <InvestmentIcon className='icon-component'/>
                <AppText fontWeight='600' color='#101828'>{row.productName}</AppText>
            </FlexRow>
        ),
        minWidth: '25rem',
        wrap: true
    },
    {
        name: <TableHeadCell>Principal Amount</TableHeadCell>,
        selector:(row: any) => <AppText color='#667085'>{moneyFormat(row.amount,false,currency)}</AppText>,
        minWidth: '17rem',
        wrap: true
    },
    // {
    //     name: <TableHeadCell>Current Balance</TableHeadCell>,
    //     selector:(row: any) => <AppText color='#667085'>&#8358;{moneyFormat(row.balance)}</AppText>,
    //     minWidth: '20rem',
    // },
    {
        name: <TableHeadCell>Maturity Date</TableHeadCell>,
        selector:(row: any) => <AppText color='#667085'>{row.maturationDate ? helpers.splitDateTime(row.maturationDate)?.date : row.maturationDate }</AppText>,
        minWidth: '15rem',
        wrap: true
    },
    {
        name: <TableHeadCell>Status</TableHeadCell>,
        selector:(row: any) => <AppText color='#667085'>{row.accountStatus || 'Unknown'}</AppText>,
        minWidth: '15rem',
        wrap: true
    },
    {
        name: <TableHeadCell></TableHeadCell>,
        selector:(row: any) => 
            <AppText 
                fontWeight='500' color='#0A756F'
                hoverColor='#667085' cursor='pointer'
                onClick={() => handleAction(row)}
            >
                View Details
            </AppText>,
        right: true
    }
]

export const investmentData = [
    {
        investment: '2',
        amount: '100000',
        date: 'Jan 4, 2022',
        txRef: '3435RET5434'
    },
    {
        investment: '3',
        amount: '100000',
        date: 'Jan 4, 2022',
        txRef: '3435RET5434'
    },
    {
        investment: '4',
        amount: '100000',
        date: 'Jan 4, 2022',
        txRef: '3435RET5434'
    }
]

export const savingsData = [
    {
        narration: 'Gadget Savings',
        amount: '100,000',
        date: 'Jan 4, 2022',
        txRef: '3435RET5434'
    },
    {
        narration: 'Card Savings',
        amount: '100,000',
        date: 'Jan 4, 2022',
        txRef: '3435RET5434'
    },
    {
        narration: 'House Savings',
        amount: '100,000',
        date: 'Jan 4, 2022',
        txRef: '3435RET5434'
    }
]

export const loanData = [
    {
        investment: 'Personal Loan',
        amount: '100000',
        date: 'Jan 4, 2022',
        txRef: '3435RET5434'
    },
    {
        investment: 'Car Loan',
        amount: '100000',
        date: 'Jan 4, 2022',
        txRef: '3435RET5434'
    },
    {
        investment: 'House Loan',
        amount: '100000',
        date: 'Jan 4, 2022',
        txRef: '3435RET5434'
    }
]

// ==================EXPENSE TRACKER =================

export const expenseTrackerColumns = (handleAction: any, currency:string, isHideBalance = false) => [
    {
        name: <TableHeadCell>Narration</TableHeadCell>,
        selector:(row: any) => (
            <FlexRow gap='1.3'>
                <BillIcon 
                    className='icon-component'
                    style={{flexBasis: 'auto', flexShrink: '0', flexGrow: '0'}}
                />
                <AppText fontWeight='600' color='#101828'>{getCharacterToDispay(row.narration, isMobileScreen ? 35 : 50)}</AppText>
            </FlexRow>
        ),
        minWidth: isMobileScreen ? '28rem' : '45rem',
        wrap: true
    },
    {
        name: <TableHeadCell>Amount</TableHeadCell>,
        selector:(row: any) => 
            <AppText color={row.debit?.trim() ? '#FB4E4E' : '#2AC769'}>
                {isHideBalance ? 'XXXXXXX' : `${row.debit?.trim() ? '-' : '+'}${moneyFormat(row.total, true,currency)}`}
            </AppText>,
        minWidth: '15rem'
    },
    {
        name: <TableHeadCell></TableHeadCell>,
        selector:(row: any) => 
            <AppText 
                fontWeight='500' color='#0A756F'
                hoverColor='#667085' cursor='pointer'
                onClick={() => handleAction(row)}
            >
                View Details
            </AppText>,
        right: true
    }
]